export class Config {
  public url: string;
  public urlSpecific: string;
  public urlLanguage: string;
  private flag: string;
  public date: Date;
  public version: string;
  public local: boolean;

  constructor() {
  }

  setValue(item: any) {
    this.url = item.url;
    this.urlSpecific = item.urlSpecific;
    this.flag = item.flag;
    this.date = item.date;
    this.version = item.version;
    this.local = item.local;
    this.urlLanguage = item.urlLanguage;
  }

  setUrlSpecific(urlSpecific: string) {
    this.urlSpecific = urlSpecific;
  }

  getUrlSpecific() {
    return this.urlSpecific;
  }

  setUrlLanguage(urlLanguage: string) {
    this.urlLanguage = urlLanguage;
  }

  geturlLanguage() {
    return this.urlLanguage;
  }

  setUrl(url: string) {
    this.url = url;
  }

  getUrl() {
    return this.url;
  }

  setFlag(flag: string) {
    this.flag = flag;
  }

  getFlag() {
    return this.flag;
  }

  setLocal(local: boolean) {
    this.local = local;
  }

  getLocal() {
    return this.local;
  }

  setDate(date: Date) {
    this.date = date;
  }

  getDate() {
    return this.date;
  }

  setVersion(version: string) {
    this.version = version;
  }

  getVersion() {
    return this.version;
  }

}
